/**
 * Created by shubham on 8/5/18.
 */

import { Component, Inject } from '@angular/core';
import { APPCONFIG } from '../config';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { dialogComponent } from '../dialog/dialog.component';
import { HttpHeaders } from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

@Component({
    selector: 'editActivityLogComponent',
    template: require('./editActivityLog.component.html'),
    providers: [HttpService, SessionHandler]

})
export class EditActivityLogComponent {

    dialogRef;
    userDetails: any;
    isSystemAdmin:boolean = false;
    isCountryManager:boolean = false;
    // adminRoles = [{"id":'Admin',"name":"Admin"},{"id":'CountryManager',"name":"Country Mannager"},{"id":'User',"name":"User"}];
    // countries = [{"id":'Germany',"name":"Germany"},{"id":'France',"name":"France"},{"id":'Italy',"name":"Italy"}];
    // selectedRole = [{"id":'User',"name":"User"}];
    adminRoles = [];
    countries = [];
    selectedRole = [];
    selectedCountries = [];
    countryMessage = '';
    roleMessage = ''
    // skipManagerApprovalFlag = true;
    settings = {};
    countrySettings = {};
    languages = [];
    defaultLanguageId: any;
    AdminForm: FormGroup;
    AdminFormDetails: any;
    emailPattern = /^[a-z0-9._]+@[a-z0-9]+\.[a-z]{2,4}/;
    namePattern = /^[a-zA-Z]+(\s[a-zA-Z]+)?$/;
    
    isDisabled = true;
    report_json = {};
    action:string;
    id:string;
    users :any = {};
    showLoader = false;
    actionTitle:string;
    showCountry:boolean =true;
    accessToken: string;
    constructor(
        private sessionHandler: SessionHandler,
        private router: Router,
        public httpService: HttpService,
        public dialog: MatDialog,
        private formBuilder: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private oktaAuthStateService: OktaAuthStateService,
        @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
    ) {
        this.oktaAuthStateService.authState$.subscribe(async (authState) => {
            if (authState.isAuthenticated) {
                const tokens = await this.oktaAuth.tokenManager.getTokens();
                this.accessToken = tokens.accessToken?.accessToken;
                this.activatedRoute.params.subscribe(params => {
                    this.action = params['action'];
                    this.activatedRoute.queryParams.subscribe((params: Params) => {
                        this.id = params['id'];
                        if ("Create" === this.action) {
                            this.getDefaultFormData();
                            this.actionTitle = "Add";
                        } else {
                            this.getEditForm(this.id);
                            this.actionTitle = "Edit";
                        }
                    });
                });
            } else {
                this.router.navigateByUrl('/extra/login');
            }
        });
    }


    public getEditForm(id: string) {
        this.showLoader = true;
    
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.accessToken}`
            })
        };
    
        this.httpService.getRequestWithHeader('activityLog/edit/' + id, httpOptions).subscribe(
            res => {
                console.log(res);
    
                if (res['message'] === 'error_occured') {
                    this.showLoader = false;
                    this.httpService.onEnd();
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = res['exp']['message'];
                    this.dialogRef.afterClosed().subscribe(result => {
                        window.location.href = '#/app/activityLog/list';
                    });
                    return;
                }
    
                this.report_json = res;
                console.log(this.report_json);
    
                let status = 'FAILED';
                let user = this.report_json['user'];
                if (this.report_json['status'] == 1) {
                    status = 'SUCCESS';
                }
                let error = this.report_json['error'];
                let requestType = this.report_json['requestType'];
                let userId = this.report_json['id'];
                let date = new Date(this.report_json['timeStamp']);
                let timeStamp = date.toString();
                let info = this.report_json['info'];
    
                this.users.user = user;
                this.users.status = status;
                this.users.error = error;
                this.users.requestType = requestType;
                this.users.timeStamp = timeStamp;
                this.users.info = info;
    
                this.httpService.onEnd();
                this.showLoader = false;
                this.buildForm();
                this.AdminForm.patchValue(this.users);
            },
            err => {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                this.showLoader = false;
                this.httpService.onEnd();
            }
        );
    }

    // public getEditForm(id){
    //     this.showLoader = true;
        
    //     this.httpService.getRequest('activityLog/edit/'+this.id).subscribe(
    //         res => {
    //             console.log(res);

                
    //             if(res['message'] == 'error_occured'){

    //                 this.showLoader = false;
        
    //                 this.httpService.onEnd();
    //                 this.dialogRef = this.dialog.open(dialogComponent);
    //                 this.dialogRef.componentInstance.msg = res['exp']['message'];
        
    //                 this.dialogRef.afterClosed().subscribe(result => {
    //                     window.location.href = '#/app/activityLog/list';
    //                 });
    //                 return;
    //              }
    //             this.report_json = res
    //             console.log(this.report_json);
    //             let status = 'FAILED';
    //             let user = this.report_json['user'];
    //             if(this.report_json['status']==1){
    //                 status = 'SUCCESS';
    //             }
    //             //let status = this.report_json['status'];
    //             let error = this.report_json['error'];
    //             let requestType = this.report_json['requestType'];
    //             let userId = this.report_json['id'];
    //             let date = new Date(this.report_json['timeStamp']);
    //             let timeStamp = date.toString();
    //             let info = this.report_json['info'];
    //             this.users.user = user;
    //             this.users.status = status;
    //             this.users.error = error;
    //             this.users.requestType = requestType;
    //             this.users.timeStamp = timeStamp;
    //             this.users.info = info;
                
    //             this.httpService.onEnd();
    //             this.showLoader = false;
    //             this.buildForm();
    //             this.AdminForm.patchValue(this.users);


    //             },
    //             err => {
    //                 this.dialogRef = this.dialog.open(dialogComponent);
    //                 this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
    //                 this.showLoader = false;
    //                 this.httpService.onEnd();
    //                 }
    //     );  
    // }

    

   public getDefaultFormData(){
    //    debugger;
    this.showLoader = true;
        let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${this.accessToken}`
            }) };
        this.httpService.getRequestWithHeader('users/create', httpOptions).subscribe(
            res => {
                console.log(res);

                if(res['message'] == 'error_occured'){

                    this.showLoader = false;
        
                    this.httpService.onEnd();
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = res['exp']['message'];
        
                    this.dialogRef.afterClosed().subscribe(result => {
                        window.location.href = '#/app/users/list';
                    });
                    return;
                 }


                this.report_json = res['dataMap'];
                console.log(this.report_json);

                let rolesArr = this.report_json['roles'];
                let countriesArr = this.report_json['countries'];
                for (var i in rolesArr) {
                    var obj = { "id": i, "name": rolesArr[i] };
                    this.adminRoles.push(obj);
                }
                for (var i in countriesArr) {
                    var obj = { "id": i, "name": countriesArr[i] };
                    this.countries.push(obj);
                }
                // this.selectedRole.push({ "id": 0, "name": rolesArr[0] });
                // this.selectedCountries.push({ "id": 0, "name": countriesArr[0] });
                // this.countryMessage = "";
                // this.roleMessage = "";
                this.httpService.onEnd();
                this.showLoader = false;
                // this.buildForm();


                },
                err => {
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                    this.showLoader = false;
                    this.httpService.onEnd();
                    }
        );  
      }
    // public getAdminRoles(){
    //     this.httpService.getRequest('superUserOperationsApi/v1/adminRoles').subscribe(
    //         res => { this.saveAdminRoles(res); },
    //         err => { this.httpService.onEnd(); }
    //     );
    // }

    // public saveAdminRoles(res){
    //     if(res && res.items){
    //         this.adminRoles = res.items;
    //     }
    //     this.httpService.onEnd();
    // }


    buildForm() {
        this.AdminForm = this.formBuilder.group({
            user: this.formBuilder.control({value:"",disabled:true},[Validators.required,Validators.pattern(this.namePattern)] ),
            status: this.formBuilder.control({value:"",disabled:true}, [Validators.required,Validators.pattern(this.namePattern)]),
            error: this.formBuilder.control({value:"",disabled:true}, [Validators.required, Validators.pattern(this.emailPattern)]),
            requestType: this.formBuilder.control({value:"",disabled:true}, [Validators.required]),
            timeStamp: this.formBuilder.control({value:"",disabled:true},[Validators.required]),
            info: this.formBuilder.control({value:"",disabled:true},[Validators.required]),
        });
        this.AdminForm.valueChanges.subscribe(data => {
            this.AdminFormDetails = this.AdminForm.getRawValue();

          
        });
    }

    public saveAdminData(){
         //debugger;
        // console.log(this.AdminForm.value);
        console.log(this.AdminFormDetails);

        const user = this.AdminFormDetails;
        if(user.status=='SUCCESS'){
            user.status=1;
        }
        else{
            user.status=0;
        }
        user.id = this.id;
        // console.log(user);

        // let body = JSON.stringify(user);
        this.showLoader = true;

        //let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new Headers({
                'Content-Type': 'application/json',
                'id': this.id
            }) };
        this.httpService.postRequestWithHeader(user,'activityLog/create',httpOptions).subscribe(
            res => { this.saveAdminResponse(res); 
            
            },
            err => { this.httpService.onEnd(); 
                this.showLoader = false;

            }
        );
    }

    public saveAdminResponse(res){
        console.log(res);
            // var jsonResponse = JSON.parse(res['_body']);
        if(res && res.message == 'success'){
          
            this.showLoader = false;

            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            if(this.action=='Edit'){
                this.dialogRef.componentInstance.msg = "User updated successfully.";
            }else{
                this.dialogRef.componentInstance.msg = "User added successfully.";
            }
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/activityLog';
            });
        }else if(res && res.message == 'error_occured'){

            this.showLoader = false;

            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.exp.message;

        
         } else {
            this.showLoader = false;

            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Not able to save details. Please try again.';
            this.httpService.onEnd();
        }
    }

    ngOnInit() {
        this.buildForm();

        this.settings = {
            singleSelection: true,
            text:"Select Role *",
            labelKey: "name",
            // selectAllText:'Select All',
            // unSelectAllText:'UnSelect All',
            classes:"myclass custom-class"
        };

        this.countrySettings = {
            singleSelection: false,
            text:"Select Country *",
            labelKey: "name",
            badgeShowLimit: 5,
            // selectAllText:'Select All',
            // unSelectAllText:'UnSelect All',
            classes:"myclass custom-class"
        };
    }
}